import React from "react";
import classnames from "classnames";

const iconLayouts = color => ({
  deleteIcon: (
    <svg
      width="12"
      height="25"
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4H1V16ZM14 1H10.5L9.5 0H4.5L3.5 1H0V3H14V1Z"
        fill={color}
      />
    </svg>
  ),
  editIcon: (
    <svg
      width="19"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.34442 12.8891L1.28887 17.4447C1.25245 17.6112 1.2537 17.7838 1.29252 17.9497C1.33134 18.1157 1.40675 18.2709 1.51323 18.4041C1.61972 18.5372 1.7546 18.6448 1.90802 18.7191C2.06144 18.7934 2.22952 18.8325 2.39998 18.8336C2.47941 18.8416 2.55944 18.8416 2.63887 18.8336L7.2222 17.778L16.0222 9.01133L11.1111 4.11133L2.34442 12.8891Z"
        fill={color}
      />
      <path
        d="M18.7889 4.62231L15.5111 1.34454C15.2956 1.13013 15.004 1.00977 14.7 1.00977C14.396 1.00977 14.1044 1.13013 13.8889 1.34454L12.0667 3.16676L16.9722 8.07232L18.7944 6.25009C18.9011 6.14291 18.9855 6.01576 19.043 5.87591C19.1004 5.73605 19.1297 5.58624 19.1292 5.43505C19.1287 5.28386 19.0984 5.13426 19.04 4.9948C18.9816 4.85534 18.8962 4.72876 18.7889 4.62231Z"
        fill={color}
      />
    </svg>
  ),
  leftArrow: (
    <svg
      width="9"
      height="15"
      viewBox="0 0 9 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.54282 0.542969L8.95703 1.95718L3.16414 7.75008L8.95703 13.543L7.54282 14.9572L0.335711 7.75008L7.54282 0.542969Z"
        fill="white"
      />
    </svg>
  ),
  lock: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9167 6.33325V5.41659C11.9167 2.88934 9.86058 0.833252 7.33333 0.833252C4.80608 0.833252 2.75 2.88934 2.75 5.41659V8.16659H1.83333C0.82225 8.16659 0 8.98884 0 9.99992V17.3333C0 18.3443 0.82225 19.1666 1.83333 19.1666H12.8333C13.8444 19.1666 14.6667 18.3443 14.6667 17.3333V9.99992C14.6667 8.98884 13.8444 8.16659 12.8333 8.16659H4.58333V5.41659C4.58333 3.90042 5.81717 2.66659 7.33333 2.66659C8.8495 2.66659 10.0833 3.90042 10.0833 5.41659V6.33325H11.9167Z"
        fill={color}
      />
    </svg>
  ),
});

const TemplateIcon = ({ onClick, className, type, color }) => {
  const icon = iconLayouts(color || "var(--active-tab-color)")[type];
  return (
    <span
      className={classnames("ml-1", className)}
      onClick={onClick}
      style={{
        cursor: "pointer",
      }}
    >
      {icon}
    </span>
  );
};

export default TemplateIcon;
